import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';

import { Order } from './order';

interface StepProps {
  count: number;
  text: string;
}

export const Step: FunctionComponent<StepProps> = ({ count, text }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={{
        xs: 'flex-start',
        sm: 'center',
      }}
      mb={2}
    >
      <Box mr={1}>
        <Order count={count} />
      </Box>
      <Typography variant="h3">{text}</Typography>
    </Box>
  );
};
